module.exports = __webpack_public_path__ + "nine.16a40c1988e23219d431.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/portfolio/worksDetails/nine/nine.jpg
// module id = ../../../../../src/assets/portfolio/worksDetails/nine/nine.jpg
// module chunks = 0